import { createStore } from '@stencil/store';
import { OnChangeHandler } from '@stencil/store/dist/types';

import { UuiTheme } from '../uui-themes/uui-theme';

export interface IUUIState {
  themes: any;
  themeRevision: number;
}

export type UuiContext = {
  theme: UuiTheme;
};

export const defaultContext: UuiContext = {
  theme: {
    name: 'default'
  }
};

let globalState;
let storeChangeHandler: OnChangeHandler<IUUIState>;

function getStoreInternal() {
  if (!globalState) {
    const { state, onChange } = createStore({
      themes: {},
      themeRevision: 0
    });

    globalState = state as any;
    storeChangeHandler = onChange as any;
  }
  return { store: globalState, storeChangeHandler };
}

export function getStore() {
  const { store } = getStoreInternal();
  return store;
}

export function getStoreChangeHandler() {
  const { storeChangeHandler } = getStoreInternal();
  return storeChangeHandler;
}
